import draftStatusIcon from "../../img/draftStatusIcon.svg";
import issuedStatusIcon from "../../img/issuedStatusIcon.svg";
import toSignStatusIcon from "../../img/toSignStatusIcon.svg";
import toCorrectStatusIcon from "../../img/toCorrectStatusIcon.svg";
import waitDischargeStatusIcon from "../../img/waitDischargeStatusIcon.svg";
import releasedStatusIcon from "../../img/releasedStatusIcon.svg";
import cancelledStatusIcon from "../../img/cancelledStatusIcon.svg";
import waitCancel from "../../img/waitCancelStatusIcon.svg";
import toSignCaptainStatusIcon from "../../img/toSignCaptainStatusIcon.svg";
import signedCaptainStatusIcon from "../../img/signedCaptainStatusIcon.svg";
import toSignCustomStatusIcon from "../../img/toSignCustomStatusIcon.svg";

export const findStatusDocument = (doc) => {

    const statusBol = {
        'DRAFT' : draftStatusIcon,
        'TO_SIGN' : toSignStatusIcon,
        'TO_CORRECT' : toCorrectStatusIcon,
        'ISSUED' : issuedStatusIcon,
        'WAIT_DISCHARGE' : waitDischargeStatusIcon,
        'RELEASED' : releasedStatusIcon,
        'WAIT_CANCEL' : waitCancel,
        'CANCELLED' : cancelledStatusIcon,
        'TO_SIGN_CAPTAIN' : toSignCaptainStatusIcon,
        'SIGNED_CAPTAIN' : signedCaptainStatusIcon,
        'TO_SIGN_CUSTOM' : toSignCustomStatusIcon
    }

        for (let key in statusBol) {
            if (doc === key) {
                return statusBol[key];
            }
        }

        return findStatusDocument;
}